import { MessageSquareText, Gauge, MapPinned } from "lucide-react";
import { T } from "@/i18n";

const steps = [
  { n: "01", icon: MessageSquareText, title: "Racconta il tuo viaggio", text: "Scrivi in linguaggio naturale dove vuoi andare, quando e con che budget." },
  { n: "02", icon: MapPinned, title: "Ricevi un piano bilanciato", text: "Giorni divisi in mattina, pomeriggio e sera, quartieri giusti e gemme locali." },
  { n: "03", icon: Gauge, title: "Migliora il tuo impatto", text: "Il TS Impact Score ti mostra come viaggiare meglio, punto dopo punto." },
];

export const HowItWorks = () => (
  <section id="come-funziona" data-testid="how-it-works-section" className="no-print bg-white py-24 md:py-32">
    <div className="mx-auto grid max-w-7xl gap-16 px-6 md:px-10 lg:grid-cols-[1fr_2fr]">
      <div>
        <p className="text-xs font-semibold uppercase tracking-widest text-emerald-700"><T>Come funziona</T></p>
        <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-gray-900 lg:text-4xl">
          <T>Meno ore a pianificare, più valore in ogni giorno.</T>
        </h2>
      </div>
      <div className="grid gap-px overflow-hidden rounded-3xl bg-emerald-100 sm:grid-cols-3">
        {steps.map(({ n, icon: Icon, title, text }) => (
          <div key={n} data-testid={`how-step-${n}`} className="group bg-white p-8 transition-colors hover:bg-emerald-50/60">
            <div className="flex items-center justify-between">
              <Icon className="h-6 w-6 text-emerald-600 transition-transform group-hover:-translate-y-1" />
              <span className="font-display text-sm font-semibold text-emerald-300">{n}</span>
            </div>
            <h3 className="mt-10 font-display text-lg font-semibold text-gray-900"><T>{title}</T></h3>
            <p className="mt-3 text-sm leading-relaxed text-gray-600"><T>{text}</T></p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
